import { render, staticRenderFns } from "./StandarPageWithListNoData.vue?vue&type=template&id=0bd2f1c8&scoped=true"
import script from "./StandarPageWithListNoData.vue?vue&type=script&lang=js"
export * from "./StandarPageWithListNoData.vue?vue&type=script&lang=js"
import style0 from "./StandarPageWithListNoData.vue?vue&type=style&index=0&id=0bd2f1c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../admin/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd2f1c8",
  null
  
)

export default component.exports